module.exports = __webpack_public_path__ + "media/庆云新闻-思创签约.f69a3fa9.mp4";